import { Suspense } from "react";

import Spinner from "@/lib/components/ui/Spinner";

export const SuspenseWrapper = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <Suspense
    fallback={
      <div className="flex h-full w-full items-center justify-center">
        <Spinner />
      </div>
    }
  >
    {children}
  </Suspense>
);
